import { Trans } from '@lingui/react/macro';
import { TutorAvatar } from './TutorAvatar';
import { Text } from '@/clients/shared-components/Typography';

export function PromoBanner(props: { to: string }) {
  return (
    <>
      <div style={{ height: 60 }} />
      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
        <div
          className={`
              opacity-90 hover:opacity-100
              bg-warm-50 hover:bg-cornflower
              transition-all duration-100
              flex justify-center items-center
              gap-4 p-2
          `}
        >
          <div className="pt-1">
            <TutorAvatar size={24} noText />
          </div>
          <Text white l>
            <Trans>Get your whole team AI-Certified.</Trans>
          </Text>
          <a href={props.to} target="_blank" rel="noopener noreferrer">
            <Text white l bold style={{ textDecoration: 'underline' }}>
              <Trans>ProfAI for Teams ›</Trans>
            </Text>
          </a>
        </div>
      </div>
    </>
  );
}
